/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

/**
 * Fix: browser back button leaves filter checkboxes out of sync with the URL,
 * causing phantom filters to be applied when a new filter is selected.
 *
 * Root cause: the theme's _onFilterChanged handler serialises the ENTIRE form
 * via FormData when any checkbox changes. If a stale checkbox is still ticked
 * (left over from a back-navigation), that stale filter gets bundled into the
 * new request, producing zero results for the impossible combination.
 *
 * Fix strategy — two layers:
 *
 * 1. CAPTURE-PHASE interceptor on filter checkbox change events.
 *    Fires before the theme's event delegation handler reads FormData.
 *    Resets every checkbox in the form (except the one being clicked) to match
 *    the actual current URL. FormData then only contains what's real + the new
 *    selection. This is the primary fix.
 *
 * 2. POPSTATE handler that resyncs checkboxes visually after back/forward nav,
 *    deferred until after the theme's AJAX has completed and replaced the form
 *    HTML. Uses a MutationObserver to detect when the form is actually updated
 *    so we can re-sync without fighting the AJAX timing.
 */
(function () {

  // ── Layer 1: intercept before FormData is read ──────────────────────────────
  document.addEventListener('change', function (e) {
    if (!e.target.matches('input[type="checkbox"][name^="filter."]')) return;

    var form = e.target.closest('form');
    if (!form) return;

    var params = new URLSearchParams(window.location.search);

    // Reset every OTHER checkbox in this form to the URL-correct state.
    // The checkbox being clicked will land in its new state naturally.
    form.querySelectorAll('input[type="checkbox"][name^="filter."]').forEach(function (cb) {
      if (cb === e.target) return;
      var active = params.getAll(cb.name).some(function (v) { return v === cb.value; });
      cb.checked = active;
    });

    // Also reset any stale range inputs
    form.querySelectorAll('input[type="number"][name^="filter."]').forEach(function (input) {
      if (!params.has(input.name)) input.value = '';
    });

  }, true); // capture phase — fires before theme's bubble-phase delegation


  // ── Layer 2: visual resync after popstate ────────────────────────────────────
  // After back/forward nav the theme fires an AJAX fetch and replaces the form
  // innerHTML. We watch for that replacement then re-sync checkboxes to the URL.
  function syncFilterCheckboxesToUrl() {
    var params = new URLSearchParams(window.location.search);
    document.querySelectorAll(
      '#desktop-filters-form input[type="checkbox"][name^="filter."], ' +
      '#mobile-collection-filters-form input[type="checkbox"][name^="filter."]'
    ).forEach(function (cb) {
      cb.checked = params.getAll(cb.name).some(function (v) { return v === cb.value; });
    });
  }

  window.addEventListener('popstate', function () {
    // Watch for the theme AJAX completing (it replaces desktopFilters.innerHTML)
    var targetForm = document.getElementById('desktop-filters-form');
    if (!targetForm) return;

    var observer = new MutationObserver(function (mutations, obs) {
      obs.disconnect();
      syncFilterCheckboxesToUrl();
    });

    observer.observe(targetForm, { childList: true, subtree: true });

    // Safety fallback: if the AJAX never mutates the form (e.g. already cached),
    // sync after a short delay anyway.
    setTimeout(function () {
      observer.disconnect();
      syncFilterCheckboxesToUrl();
    }, 2000);
  });

})();


/* AM Klaviyo Added-to-Cart bridge START — 2026-05-17 */
(function () {
  if (window.__amKlaviyoAddedToCartBridgeLoaded) return;
  window.__amKlaviyoAddedToCartBridgeLoaded = true;

  document.addEventListener('product:added', function (event) {
    if (!event.detail || event.detail.productAdded !== true) return;

    var button = event.detail.button;
    var form = button && button.closest
      ? button.closest('form[action*="/cart/add"]')
      : null;

    if (!form && event.target && event.target.closest) {
      form = event.target.closest('form[action*="/cart/add"]');
    }

    if (!form) return;

    var variantIdInput = form.querySelector('[name="id"]');
    var quantityInput = form.querySelector('[name="quantity"]');
    var productIdInput = form.querySelector('[name="product-id"]');

    var variantId = variantIdInput ? variantIdInput.value : undefined;
    var productId = productIdInput ? productIdInput.value : undefined;
    var quantity = Number(
      quantityInput && quantityInput.value
        ? quantityInput.value
        : event.detail.quantity || 1
    );

    var titleMeta = document.querySelector('meta[property="og:title"]');
    var urlMeta = document.querySelector('meta[property="og:url"]');
    var imageMeta = document.querySelector('meta[property="og:image:secure_url"], meta[property="og:image"]');
    var priceMeta = document.querySelector('meta[property="product:price:amount"]');

    var title = titleMeta && titleMeta.content
      ? titleMeta.content
      : (document.querySelector('h1') ? document.querySelector('h1').textContent.trim() : undefined);

    var url = urlMeta && urlMeta.content
      ? urlMeta.content
      : window.location.href.split('?')[0];

    var image = imageMeta && imageMeta.content ? imageMeta.content : undefined;
    var price = priceMeta && priceMeta.content
      ? Number(priceMeta.content.replace(/[^0-9.]/g, ''))
      : undefined;

    var payload = {
      ProductID: productId,
      VariantID: variantId,
      Name: title,
      'Product Name': title,
      URL: url,
      ImageURL: image,
      Quantity: quantity,
      Price: price,
      Value: price ? price * quantity : undefined,
      Currency: 'GBP'
    };

    if (window.klaviyo && typeof window.klaviyo.track === 'function') {
      window.klaviyo.track('Added to Cart', payload);
    } else {
      window._learnq = window._learnq || [];
      window._learnq.push(['track', 'Added to Cart', payload]);
    }
  });
})();
/* AM Klaviyo Added-to-Cart bridge END — 2026-05-17 */
